import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ILogin } from "@models/ILogin";
import { IPasswordCambiar } from "@models/IPassWordRecuperar";
import { IUserModel } from "@models/IUserModel";
import { environment } from "environments/environment";
import { map, Observable } from "rxjs";
import { SessionService } from "./session.service";

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(
        private http: HttpClient,
        private sessionService: SessionService,
    ) { }


    login(credenciales: ILogin) {
        return this.http
            .post<IUserModel>(environment.API_URL + 'login/autenticacion', credenciales, {
                observe: 'response',
                withCredentials: true,
            })
            .pipe(map((resp) => resp.body as IUserModel));
    }


    logoutRequest() {
        this.sessionService.clearSessionState();
        return this.http.post(environment.API_URL + 'auth/logout', {});
    }

    changePassword(passwordCambiar: IPasswordCambiar) {
        return this.http.post(environment.API_URL + 'usuario/password/cambiar', passwordCambiar);
    }

    recuperarPassword(usuario: string): Observable<any> {
        return this.http.post(environment.API_URL + 'usuario/password/recuperar', { usuario });
    }

    cambiarRecuperarPassword(passwordCambiar: IPasswordCambiar, token: string) {
        return this.http.post(environment.API_URL + 'usuario/password/recuperar/cambiar', {
            passwordCambiar,
            token,
        });
    }

    comprobarBloqueoUsuario(username: string, numMaxIntentos: number): Observable<boolean> {
        return this.http.get<boolean>(`${environment.API_URL}usuario/bloqueo`, {
            params: {
                username,
                numMaxIntentos,
            },
        });
    }

    guardarIntentoFallido(username: string, fecha: Date, numMaxIntentos: number, minBloqueo: number): Observable<any> {
        return this.http.put(`${environment.API_URL}usuario/bloqueo`, {
            username,
            fecha,
            numMaxIntentos,
            minBloqueo,
        });
    }

    sendEmailForgotPassWord(email: string, subject: string, body: string, callbackUrl: string): Observable<any> {
        return this.http.post(`${environment.API_URL}usuario/forgot-password/enviar-email`, {
            email,
            subject,
            body,
            callbackUrl,
        });
    }
}